import React, { useState, useEffect } from "react";
import { FiPlay, FiPause, FiRotateCcw, FiClock } from "react-icons/fi";

const DSATimer = ({ initialTime = "30Min" }) => {
  const [seconds, setSeconds] = useState(0);
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    let interval = null;
    if (isActive) {
      interval = setInterval(() => {
        setSeconds((prev) => prev + 1);
      }, 1000);
    } else if (!isActive && seconds !== 0) {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [isActive, seconds]);

  const toggleTimer = () => {
    setIsActive(!isActive);
  };

  const resetTimer = () => {
    setSeconds(0);
    setIsActive(false);
  };

  const formatTime = (totalSecs) => {
    const mins = Math.floor(totalSecs / 60);
    const secs = totalSecs % 60;
    return `${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };

  return (
    <div className="inline-flex items-center space-x-1.5 bg-slate-100 dark:bg-slate-950/80 px-2.5 py-1 rounded-lg border border-slate-200 dark:border-slate-800">
      <FiClock className={`w-3.5 h-3.5 ${isActive ? "text-amber-500 dark:text-amber-400 animate-pulse" : "text-slate-500 dark:text-slate-400"}`} />
      <span className={`font-mono text-xs font-bold ${isActive ? "text-amber-600 dark:text-amber-300" : "text-slate-700 dark:text-slate-300"}`}>
        {seconds > 0 ? formatTime(seconds) : initialTime}
      </span>
      
      <div className="flex items-center space-x-1 ml-1">
        <button
          onClick={toggleTimer}
          className={`p-1 rounded-md transition-all cursor-pointer ${
            isActive
              ? "bg-amber-500/20 text-amber-600 dark:text-amber-300 hover:bg-amber-500/30"
              : "bg-emerald-500/20 text-emerald-600 dark:text-emerald-300 hover:bg-emerald-500/30"
          }`}
          title={isActive ? "Pause Timer" : "Start Timer"}
        >
          {isActive ? <FiPause className="w-3 h-3" /> : <FiPlay className="w-3 h-3" />}
        </button>

        <button
          onClick={resetTimer}
          style={{ display: seconds > 0 ? "inline-flex" : "none" }}
          className="p-1 rounded-md bg-slate-200 dark:bg-slate-800 hover:bg-slate-300 dark:hover:bg-slate-700 text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white transition-all cursor-pointer items-center justify-center"
          title="Reset Timer"
        >
          <FiRotateCcw className="w-3 h-3" />
        </button>
      </div>
    </div>
  );
};

export default DSATimer;
